module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/issue-main-mobile.caafa024.jpg";